var _linearGradient, _clipPath, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnaconda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81,
    height: 20,
    role: "img",
    "aria-label": "Anaconda",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Anaconda") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 81,
    height: 20,
    fill: "#44a833"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,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"
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 495,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 530
  }, "Anaconda"), /*#__PURE__*/React.createElement("text", {
    x: 495,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 530
  }, "Anaconda"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnaconda);
export default __webpack_public_path__ + "static/media/anaconda.c0e283c0f350b752e81f947d3ea7b2aa.svg";
export { ForwardRef as ReactComponent };